'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Comment.tsx
var SvgComment = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M7.768 2.25h8.464c.813 0 1.469 0 2 .043.546.045 1.026.14 1.47.366a3.75 3.75 0 0 1 1.64 1.639c.226.444.32.924.365 1.47.043.531.043 1.187.043 2v5.464c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H9.684c-.654 0-.877.003-1.084.046-.199.04-.39.108-.571.2-.188.096-.364.233-.875.642l-2.409 1.926c-.188.15-.367.294-.522.396-.15.1-.402.25-.722.25-.38 0-.74-.173-.978-.47-.2-.25-.24-.542-.256-.72a7.815 7.815 0 0 1-.017-.655V7.768c0-.813 0-1.469.043-2 .045-.546.14-1.026.366-1.47a3.75 3.75 0 0 1 1.639-1.64c.444-.226.924-.32 1.47-.365.531-.043 1.187-.043 2-.043ZM5.89 3.788c-.454.037-.715.107-.912.207a2.25 2.25 0 0 0-.984.984c-.1.197-.17.458-.207.912-.037.462-.038 1.057-.038 1.909v12.639l.081-.064 2.386-1.909.056-.045c.433-.347.733-.587 1.073-.76.301-.154.621-.267.952-.334.375-.077.759-.077 1.313-.077h6.59c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.056.038-1.909V7.8c0-.852 0-1.447-.038-1.91-.038-.453-.107-.714-.207-.911a2.25 2.25 0 0 0-.983-.984c-.198-.1-.459-.17-.913-.207-.462-.037-1.057-.038-1.909-.038H7.8c-.852 0-1.447 0-1.91.038ZM6.25 8.5A.75.75 0 0 1 7 7.75h5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z" }));
var Comment_default = SvgComment;

module.exports = Comment_default;
